const levelName = process.env["REACT_APP_LOG_LEVEL"] || "info";
const levels = ["error", "warn", "info", "debug"];
const minLevelIndex = Math.max(0, levels.indexOf(levelName));
const allowed = new Set(levels.slice(minLevelIndex));
const formatArg = (arg) => {
    if (typeof arg === "string")
        return arg;
    try {
        return JSON.stringify(arg);
    }
    catch {
        return String(arg);
    }
};
const logger = {
    error: (...args) => allowed.has("error") && console.error(...args.map((arg) => formatArg(arg))),
    warn: (...args) => allowed.has("warn") && console.warn(...args.map((arg) => formatArg(arg))),
    info: (...args) => allowed.has("info") && console.info(...args.map((arg) => formatArg(arg))),
    debug: (...args) => allowed.has("debug") && console.debug(...args.map((arg) => formatArg(arg))),
};
export default logger;
